'use client';

import * as Yup from 'yup';
import { useTranslation } from 'react-i18next';
import { useMoneyStore } from '@/infrastructure/zustand/moneyStoreProvider';

export const useValidationSchema = () => {
	const [trans] = useTranslation();
	const exchangeRates = useMoneyStore((state) => state.exchangeRates);
	const currentCurrencyCode = useMoneyStore((state) => state.currentCurrencyCode);

	return Yup.object().shape({
		name: Yup.string().required(
			trans('validationIsRequired', {
				label: trans('name'),
			}),
		),
		lastName: Yup.string().required(
			trans('validationIsRequired', {
				label: trans('lastName'),
			}),
		),
		amount: Yup.number().min(1, trans('amountMustBeGreaterThanZero')),
		customAmount: Yup.number().min(1, trans('amountMustBeGreaterThanZero')),
		certificated: Yup.boolean(),
		telefonicaTermsAndConditions: Yup.boolean().oneOf([true], trans('validationIsRequired', { label: '' })),
		termsAndConditions: Yup.boolean().when('subscribeNewsletter', {
			is: true,
			then: (schema) => schema.oneOf([true], trans('validationIsRequired', { label: '' })),
		}),
		ngoTermsAndConditions: Yup.boolean()
			.when('certificated', {
				is: true,
				then: (schema) => schema.oneOf([true], trans('validationIsRequired', { label: '' })),
			})
			.when('amount', {
				is: (amount: number) => amount / (exchangeRates[currentCurrencyCode] ?? 1) >= 100,
				then: (schema) => schema.oneOf([true], trans('validationIsRequired', { label: '' })),
			}),
		company: Yup.string().when('donationHolder', {
			is: 'company',
			then: (schema) =>
				schema.required(
					trans('validationIsRequired', {
						label: trans('company'),
					}),
				),
		}),
		email: Yup.string()
			.email()
			.required(
				trans('validationIsRequired', {
					label: trans('email'),
				}),
			),
		repeatedEmail: Yup.string()
			.email()
			.nullable()
			.oneOf([Yup.ref('email'), null])
			.required(
				trans('validationEqualFields', {
					label: trans('email'),
					fieldName: trans('repeatEmail'),
				}),
			),
		country: Yup.string().required(
			trans('validationIsRequired', {
				label: trans('country'),
			}),
		),
		documentNumber: Yup.string().required(
			trans('validationIsRequired', {
				label: trans('documentNumber'),
			}),
		),
		streetName: Yup.string().required(
			trans('validationIsRequired', {
				label: trans('streetName'),
			}),
		),
		streetNumber: Yup.string().required(
			trans('validationIsRequired', {
				label: trans('streetNumber'),
			}),
		),
		postalCode: Yup.string().required(
			trans('validationIsRequired', {
				label: trans('postalCode'),
			}),
		),
		city: Yup.string().required(
			trans('validationIsRequired', {
				label: trans('city'),
			}),
		),
		region: Yup.string(),
		province: Yup.string(),
		metafields: Yup.object().shape({
			noTicket: Yup.boolean(),
			tickets: Yup.number(),
		}),
	});
};
